import React, { FC, ReactNode } from 'react';
import { DinersLogo } from '../../../atoms/card_brands/DinersLogo';
import { JCBLogo } from '../../../atoms/card_brands/JCBLogo';
import { DiscoverLogo } from '../../../atoms/card_brands/DiscoverLogo';
import { VisaLogo } from '../../../atoms/card_brands/VisaLogo';
import { MasterCardLogo } from '../../../atoms/card_brands/MasterCardLogo';
import { AmexLogo } from '../../../atoms/card_brands/AmexLogo';
import css from './CardBrandList.module.scss';

type LogoWrapperProps = {
  children: ReactNode;
};
const LogoWraper: FC<LogoWrapperProps> = ({ children }) => {
  return <div className={css.logo_wrapper}>{children}</div>;
};

const JCBBrands = () => {
  return (
    <>
      <LogoWraper>
        <DinersLogo />
      </LogoWraper>
      <LogoWraper>
        <JCBLogo />
      </LogoWraper>
      <LogoWraper>
        <DiscoverLogo />
      </LogoWraper>
    </>
  );
};

type Props = {
  isJCBEnabled: boolean;
};

export const CardBrandList: FC<Props> = ({ isJCBEnabled }) => {
  return (
    <div className={css.container}>
      <LogoWraper>
        <VisaLogo />
      </LogoWraper>
      <LogoWraper>
        <MasterCardLogo />
      </LogoWraper>
      <LogoWraper>
        <AmexLogo />
      </LogoWraper>
      {isJCBEnabled && <JCBBrands />}
    </div>
  );
};
